import { AccentFoldService, AddOnTypes, AppService, ColorPickerService, CommonMapService, StringDateTimePipe, CoreProxyService, CoreTypes, IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts, LabelValue, CommonCloudstudioService, StringMomentDateTimePipe } from 'common-cloudstudio';
import { Subscription, Observable, forkJoin } from 'rxjs';
import { GearProxyService, GearTypes, GearAppService } from 'common-gear';
import { Component, OnInit, ViewChild, OnDestroy, AfterViewInit, Optional } from '@angular/core';
import { MapService } from '../../shared/services/map.service';
import { Router, ActivatedRoute } from "@angular/router";
import { MapsAPILoader } from '@agm/core';
import { SharedService } from '../../shared/services/shared.service';
import { GoogleMap } from '@angular/google-maps';
import { MarkerClusterer, SuperClusterAlgorithm } from "@googlemaps/markerclusterer";
import { ApolusProxyService, ApolusTypes } from 'src/app/customer-modules/apolus/shared/services/apolus-proxy.service';

declare let environment: any;

const customMapIndicator: number = 1111000000;

export interface ExtendedCustomMapValues extends CoreTypes.CustomMapValues, CoreTypes.ConsumptionCustomMapValues, CoreTypes.MetricCustomMapValues { }
export interface ExtendedCustomMapBase extends CoreTypes.CustomMapDataPacketBase {
  CustomMapType: CoreTypes.CustomMapType;
}

export interface ExtendedCustomMap extends ExtendedCustomMapBase {
  Data: CoreTypes.CustomMap[];
}

export interface ExtendedMetricCustomMap extends ExtendedCustomMapBase {
  Data: CoreTypes.MetricCustomMap[];
}

export type ExtendedCustomMapUnion = ExtendedCustomMap | ExtendedMetricCustomMap;
export interface CustomMap extends Omit<CoreTypes.CustomMap, 'Points'> {
  Points: ExtendedCustomMapValues;
}

interface Metadata {
  id: any;
}

interface IconMarker {
  latitude: number;
  longitude: number;
  url: string | google.maps.ReadonlyIcon | google.maps.ReadonlySymbol;
  html?: string;
  metadata: Metadata;
  pointColor?: string;
}

// Interfaz para los facilities con información de batería
interface FacilityWithBattery {
  name: string;
  image: string;
  location: string;
  normalBatteryCount: number;
  mediumBatteryCount: number;
  lowBatteryCount: number;
}

@Component({
  selector: 'app-custom-map',
  templateUrl: './custom-map.component.html',
  styleUrls: ['./custom-map.component.scss'],
})

export class CustomMapComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('customMapModal') public _customMapModal: any;
  @ViewChild(GoogleMap, { static: false }) mapComponent!: GoogleMap;

  bounds: any;
  _lastOpenInfoWindow: any;
  infoWindow!: google.maps.InfoWindow;
  _longitudeCenter: number = -105.012516;
  _latitudeCenter: number = 10.875404;
  _zoom: number = 1.9;
  _mapWidth: string;
  map!: google.maps.Map;
  clusterer!: MarkerClusterer;
  mapDefinition: CoreTypes.MapDefinition;
  enableHeatmap: boolean = false;
  heatmap: google.maps.visualization.HeatmapLayer | null = null;
  heatmapData: (google.maps.LatLng | google.maps.visualization.WeightedLocation)[] = [];
  heatmapMarkers: google.maps.Marker[] = [];
  clustersFullList: {
    customMap: CustomMap;
    markerData: IconMarker;
  }[] = [];
  clustersFilteredList: {
    customMap: CustomMap;
    markerData: IconMarker;
  }[] = [];
  _activeMarker: number;
  markers: google.maps.Marker[] = [];
  markerClusterer: any;
  
  AdvancedMarkerElement: any;
  PinElement: any;
  
  showIndividualMarkers: boolean = true;
  private readonly CLUSTER_ZOOM_THRESHOLD = 12;
  private currentZoom: number = 0;
  _dataPacketSub: Subscription;
  _pathsUtilityCompanies: any;
  _pathsMaintenanceContractors: any;
  _customMapModalId: number;
  subscriptions: Subscription[] = [];

  _successMessage: string;
  _errorMessage: string;

  _deviceID : number;
  devicesOpts : Array<IMultiSelectOption>  = [];
  devicesList : number[] = [];
  devices: number[] = [];
  devicesIDs: number[] = [];

  devicesFullList : CoreTypes.Device[];
  customMapData: CoreTypes.CustomMapDataPacketDetail;

  executionNumber: number = 0;
  searchText: string = '';
  clientID: number;
  facilityID: number;
  firstExecution: boolean = true;
  activeTab = 0;
  facilityData: GearTypes.GearMapFacility = new GearTypes.GearMapFacility();
  facilitiesIds: number[] = [];
  facilitiesList: Array<IMultiSelectOption> = [];
  _facilityID: number;
  status: number = 0;
  _facilityType: LabelValue<number>;
  _facilityTypesList: LabelValue<number>[] = new Array<LabelValue<number>>();
  _multiSelectSettings: IMultiSelectSettings = {
    enableSearch: true,
    checkedStyle: 'checkboxes',
    dynamicTitleMaxItems: 1,
    displayAllSelectedText: true,
    showCheckAll: true,
    showUncheckAll: true,
    
  };
  _multiSelectTexts: IMultiSelectTexts = {
    checkAll: this._appService.CoreCommonLiterals.MultiSelect_All_Male, // 'Select all'
    uncheckAll: this._appService.CoreCommonLiterals.None_Male, // 'Unselect all'
    checked: this._appService.CoreCommonLiterals.MultiSelect_X_Selected_Male, // 'item selected'
    checkedPlural: this._appService.CoreCommonLiterals.MultiSelect_X_Selected_Male,
    searchPlaceholder: this._appService.CoreCommonLiterals.MultiSelect_Find, //'Find'
    defaultTitle: this._appService.CoreCommonLiterals.Select, // 'Select'
    allSelected: this._appService.CoreCommonLiterals.MultiSelect_All_Male // 'All selected'
  };
  
  facilities: number[] = [];
  _facilityParameter: CoreTypes.Facility = {
    ...new CoreTypes.Facility(),
    Location: {
      Latitude: null,
      Longitude: null
    }
  };
  _selectedFacility: LabelValue<number>[] = new Array<LabelValue<number>>();
  _defaultFacility: LabelValue<number>;
  consumptionVariableList: Array<IMultiSelectOption> = [];
  consumptionVariables: any[] = [];

  _variablesTypeList: LabelValue<number>[] = [];
  _variablesTypeFullList: any[] = [];
  _variableType: LabelValue<number> = { value: 0, label: null };
  _allowedVariableTypes: number[] = [];
  debounceAction: any;

  private _destroyed = false;
  private _sequenceNumber = 0;
  private timer: any;
  private indexTable: Array<number> = [];
     private _lastClusteringData: string = '';
   private _isUpdatingClustering = false;
   private _currentTooltipMarker: google.maps.Marker | null = null;
   private _isMouseOverTooltip: boolean = false;
   private _tooltipTimeout: any;
   private _heatmapTooltipTimeout: any;
   private _currentHeatmapMarker: google.maps.Marker | null = null;
   private _lastFacilityId: number = 0;
   private _tooltipCache: { [key: string]: string } = {};
  addOnFeatureVisibility = AddOnTypes.AddOnVisibilityTypes;
  addOnFeatureIDs = AddOnTypes.AddOnFeatureIDs;
  addOnMapping:GearTypes.BasicMasterEntityAddOnFeatures = new GearTypes.BasicMasterEntityAddOnFeatures();
  maxPanelWidth: number = 700;
  environment = environment;

  initialPanelWidth: number = 380;
  _paramSelected: CoreTypes.FormParameter = new CoreTypes.FormParameter();
  enableFilter: boolean = true;
  formParameterList: CoreTypes.FormParameter[] = [];
  formParameterApplied: CoreTypes.FormParameter[] = [];
  visualizationType: LabelValue<number> = new LabelValue<number>();
  visualizationTypeList: LabelValue<number>[] = [];
  mapId: number = 0;
  
  variable: LabelValue<number> = new LabelValue<number>();
  variableList: LabelValue<number>[] = [];
  facilitiesWithBattery: FacilityWithBattery[] = [];
  activeIcon: number = 1;
  mapApiReady: boolean = false;
  googleMapOptions: any;
  customMapID: number;
  initialLatitude: number;
  initialLongitude: number;

  constructor(
    public _mapService: MapService,
    public commonMapService: CommonMapService,
    private _gearProxyService: GearProxyService,
    public _appService: AppService,
    private _router: Router,
    public _gearService: GearAppService,
    public mapsAPILoader: MapsAPILoader,
    private _accentFoldService: AccentFoldService,
    private sharedService: SharedService,
    private _coreProxyService: CoreProxyService,
    private colorService: ColorPickerService,
    private _activatedRoute: ActivatedRoute,
    @Optional() private apolusProxy?: ApolusProxyService
  ) {}

  private closeInfoWindowHandler = () => this.hideTooltip();
  
  async ngOnInit() {
    window.addEventListener('close-info-window', this.closeInfoWindowHandler);
    
    try {
      let map = await this._mapService.load();
      if(map) {
        this.mapApiReady = true;
        this.googleMapOptions = {
          styles: this.commonMapService.Styles,
          maxZoom: this.commonMapService.MaxZoom,
          mapTypeId: 'roadmap',
          gestureHandling: 'greedy',
          zoomControl: true,
          mapTypeControl: true,
          mapTypeControlOptions: {
            style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
            position: google.maps.ControlPosition.TOP_LEFT
          },
          streetViewControl: true,
          fullscreenControl: true,
          mapId: 'custom-map-id'
        };
      }
    } catch (error) {}
    
    this.maxPanelWidth = window.innerWidth*0.7 - 260;
    this._facilityID = this._appService.getFacilityID();
    this.status = 0;
    this.addOnMapping = this._gearService.addOnFeaturesPermissionsList?.find(add => add.AddOnFeatureID == this.addOnFeatureIDs.Mapping);

    this._activatedRoute.params.subscribe(params => {
      if (params['id']) {
        this.mapId = +params['id'];
        this.customMapID = this.extractCustomMapID(this.mapId);
        this.getMapDefinition();
        this.initData();
      }
    });

    this.subscriptions.push(this._appService.onClientDescriptionSet.subscribe(description => {
      if(this.clientID && this.clientID !== this._appService.getClientID()) { this.back(); }
    }));
    
    this.subscriptions.push(this._gearService.onChangeFacilityID.subscribe(facilityID => {
      if (this._facilityID === facilityID) { return; }
      this.status = 0;
      this._facilityID = this._appService.getFacilityID();
      this._lastClusteringData = '';
      this._isUpdatingClustering = false;
      this.clearHeatmapData();
      this.getFacilities();
    }));

    this.getFacilities();
    this.loadConsumptionVariables();
  }

  ngAfterViewInit(): void {
    const waitForMap = setInterval(() => {
      if (this.mapComponent?.googleMap) {
        clearInterval(waitForMap);
        this.onMapReady(this.mapComponent.googleMap);
      }
    }, 100);
  }
  
  ngOnDestroy() {
    window.removeEventListener('close-info-window', this.closeInfoWindowHandler);
    
    clearTimeout(this.timer);
    clearTimeout(this.debounceAction);
    this._destroyed = true;
    this.debounceAction = null;
    this._dataPacketSub?.unsubscribe();
    this.subscriptions.forEach(s => s.unsubscribe());
    
    // Limpiar markers y recursos del mapa
    this.clearClustering();
    
    if (this.heatmap) {
      this.heatmap.setMap(null);
      this.heatmap = null;
    }
    
    this._tooltipCache = {};
    this.clustersFullList = [];
    this.clustersFilteredList = [];
    this.indexTable = [];
    this._tooltipCache = {};
  }

  initData() {
    clearTimeout(this.timer);
    this._sequenceNumber = 0;
    this.status = 0;
    this.indexTable = [];
    this.clustersFullList = [];
    this.clustersFilteredList = [];
    this.facilitiesIds = [];
    this.clearHeatmapData();
    this.searchText = '';
    this.firstExecution = true;
    
    const currentFacilityId = this._appService.getFacilityID();
    this._lastFacilityId = currentFacilityId;
    this._lastClusteringData = '';
    this._isUpdatingClustering = false;
    
    if (this.map) {
      this.map.setCenter(new google.maps.LatLng(this._latitudeCenter, this._longitudeCenter));
      this.map.setZoom(this._zoom);
      this.currentZoom = this._zoom;
      this.showIndividualMarkers = this.currentZoom >= this.CLUSTER_ZOOM_THRESHOLD;
    }
    this.clearClustering();
    this.getRecursively();
  }

  getRecursively() {
    this.addOnMapping = this._gearService.addOnFeaturesPermissionsList?.find(add => add.AddOnFeatureID == this.addOnFeatureIDs.Mapping);
    if(this._destroyed || (!this.addOnMapping?.Enabled &&(this.addOnMapping?.Visibility === this.addOnFeatureVisibility.ShowStar || this.addOnMapping?.Visibility === this.addOnFeatureVisibility.Visible))) { return;}
    if(this._dataPacketSub) { this._dataPacketSub.unsubscribe(); }
    this._dataPacketSub = this.getDataPackages().subscribe(data => {
      this.status = 1;
      this.getRecursively();
    }, (interval) => {
      this.timer = setTimeout(()=> this.getRecursively(), interval);
    })
  }

  getFacilities() {
    if( !this._appService.getClientID()){ return; }
    this.facilitiesList = [];
    this.facilitiesIds = [];
    this.facilities = [];
    let optionsList: Array<IMultiSelectOption> = new Array<IMultiSelectOption>();
    this._coreProxyService.FacilityService.EnumFacilities(
      this._appService.getAccessToken(),
      this._appService.getClientID(),
      res => {
        res.forEach(x => {
          let item = {
            name: x.Description,
            id: x.FacilityID
          }
          optionsList.push(item);
          this.facilitiesIds.push(x.FacilityID);
          this.facilities.push(x.FacilityID);
                 });
         this.facilitiesList = optionsList;
         if (this.map) {
           this.initData();
         }
         // this.facilitiesList.length === this.params.FacilitiesIDs.length ? this.default.setValue(true) : this.default.setValue(false);
       }, 
      e => {
        this._appService.showException(e);
      }
    );
  }

  getMapDefinition(): void {
    this.mapDefinition = new CoreTypes.MapDefinition();
    this.mapDefinition.LayerType = [CoreTypes.MapLayerType.Roadmap, CoreTypes.MapLayerType.Satellite, CoreTypes.MapLayerType.Heatmap, CoreTypes.MapLayerType.Terrain, CoreTypes.MapLayerType.Hybrid];
    setTimeout(() => {
      this.setDefaultVisualizationType();
    }, 400);

    this._gearProxyService.RealTimeDataService.GetMapDefinition(
      this._appService.getAccessToken(),
      CoreTypes.MapType.ClientCustomMap,
      this._facilityID,
      this.formParameterApplied,
      this.mapId,
      (res: CoreTypes.MapDefinition) => {
        this.mapDefinition = res;
        this.setDefaultVisualizationType();
      },
      (err: any) => {
        this._appService.showException(err);
      }
    ); 
  }

  extractCustomMapID(mapId: number, customMapIndicator: number = 1111000000): number | null {
    try {
      const mapIdStr = mapId.toString();
      const indicatorStr = customMapIndicator.toString();
      
      if (!mapIdStr.startsWith(indicatorStr)) { return null; }
      const customMapIDStr = mapIdStr.substring(indicatorStr.length);
      if (customMapIDStr.length === 0) { return null; }
      const customMapID = parseInt(customMapIDStr, 10);
      if (isNaN(customMapID)) { return null; }
      return customMapID;
    } catch (error) {
      return null;
    }
  }

  setDefaultVisualizationType() {
    this.visualizationTypeList = this.mapDefinition.LayerType.map(layerType => {
      let label = '';
      switch (layerType) {
        case CoreTypes.MapLayerType.Roadmap:
          label = this._appService.CoreCommonLiterals.Standard;
          break;
        case CoreTypes.MapLayerType.Satellite:
          label = this._appService.CoreCommonLiterals.Satellite;
          break;
        case CoreTypes.MapLayerType.Heatmap:
          label = this._appService.CoreCommonLiterals.HeatMapView;
          break;
        case CoreTypes.MapLayerType.Terrain:
          label = this._appService.CoreCommonLiterals.LandViewType;
          break;
        case CoreTypes.MapLayerType.Hybrid:
          label = this._appService.CoreCommonLiterals.HybridMapView;
          break;
        default:
          label = this._appService.CoreCommonLiterals.Standard;
      }
      return { label: label, value: layerType };
    });
    
    if (this.mapDefinition.DefaultLayer) {
      this.visualizationType = this.visualizationTypeList.find(x => x.value === this.mapDefinition.DefaultLayer);
    } else {
      this.visualizationType = this.visualizationTypeList[0];
    }
    this.enableHeatmap = this.visualizationType.value === CoreTypes.MapLayerType.Heatmap;
    if(this.enableHeatmap) {
      setTimeout(() => {
        this.clearClustering();
        this.generateHeatmapData();
        this.createHeatmapButtons();
      }, 500);
    }
  }

  getDataPackages(): Observable<number> {
    this.executionNumber++;
    let executionNumber: number = this.executionNumber;
    return new Observable(observer => {
      if(!this._appService.onMapIconDetails.value || !this.mapId) {
        setTimeout(() => {
          observer.next(); 
        }, 1000);
        return; 
      }
      this._gearProxyService.RealTimeDataService.GetCustomMapDataPacket(
        this._appService.getAccessToken(),
        this._appService.getClientID(),
        this.mapId,
        this._sequenceNumber,
        100,
        (success: ExtendedCustomMapUnion) => {
          this.status = 1;
          // Controlar que el request que se está ejecutando en este success sea el ultimo ejecutado por el programa
          if(executionNumber !== this.executionNumber) {
            this.firstExecution = false;
            observer.next();
            return;
          }
          try {
            if (this._sequenceNumber > success.HightestSequenceNumber) {
              return observer.next();
            }

            this._sequenceNumber = success.HightestSequenceNumber;

            if (this.firstExecution) {
              if (success.InitialViewSW && success.InitialViewNE) {
                var sw = new google.maps.LatLng(success.InitialViewSW.Latitude, success.InitialViewSW.Longitude);
                var ne = new google.maps.LatLng(success.InitialViewNE.Latitude, success.InitialViewNE.Longitude);
                this.bounds = new google.maps.LatLngBounds(sw, ne);
                            
                this.initialLatitude = (sw.lat() + ne.lat()) / 2;
                this.initialLongitude = (sw.lng() + ne.lng()) / 2;
              } else {
                this.initialLatitude = this._latitudeCenter;
                this.initialLongitude = this._longitudeCenter;
              }
            
              setTimeout(() => this.centerMapInitially(), 100);
            }

            const sites = success.Data as CustomMap[];
            let refreshed = [];

            const markersToUpdate = [];
            for (let index = 0; index < sites.length; index++) {
              refreshed.push(sites[index].EndpointID);
              markersToUpdate.push(sites[index]);
            }
            
            this.processMarkersInBatches(markersToUpdate);

            if (this.firstExecution) {
              this.map.fitBounds(this.bounds);
              setTimeout(async () => {
                if (this.enableHeatmap) {
                  this.generateHeatmapData();
                  return;
                }
                
                this.currentZoom = this.map.getZoom();
                // Asegurar que el zoom permita clustering al inicio
                if (this.currentZoom >= this.CLUSTER_ZOOM_THRESHOLD) {
                  this.map.setZoom(this.CLUSTER_ZOOM_THRESHOLD - 1);
                  this.currentZoom = this.CLUSTER_ZOOM_THRESHOLD - 1;
                }
                this.showIndividualMarkers = this.currentZoom >= this.CLUSTER_ZOOM_THRESHOLD;
                
                if (this.currentZoom < this.CLUSTER_ZOOM_THRESHOLD) {
                  this._lastClusteringData = '';
                  this._isUpdatingClustering = false;
                  await this.updateClustering();
                } else {
                  if (this.clusterer) {
                    this.clusterer.clearMarkers();
                    this.clusterer = null;
                  }
                  this.showIndividualMarkersOnMap();
                }
              }, 100);
            } else {
              setTimeout(async () => {
                if (this.enableHeatmap) {
                  this.generateHeatmapData();
                  return;
                }
                
                this.currentZoom = this.map.getZoom();
                this.showIndividualMarkers = this.currentZoom >= this.CLUSTER_ZOOM_THRESHOLD;
                if (this.currentZoom < this.CLUSTER_ZOOM_THRESHOLD) {
                  await this.updateClustering();
                } else {
                  if (this.clusterer) {
                    this.clusterer.clearMarkers();
                    this.clusterer = null;
                  }
                  this.showIndividualMarkersOnMap();
                }
              }, 100);
            }
            this.firstExecution = false;
            observer.next();
          } catch (error) {
            observer.error(5000);
          }
        },
        err => {
          this.status = 2;
          this._appService.showException(err);
          observer.error(15000);
        }
      );
    });
  }

  centerMapInitially() {
    if (!this.map) return;

    if (this.initialLatitude && this.initialLongitude) {
      this.map.setCenter(new google.maps.LatLng(this.initialLatitude, this.initialLongitude));
      const initialZoom = 1.9;
      this.map.setZoom(initialZoom);
      this.currentZoom = initialZoom;
      this.showIndividualMarkers = this.currentZoom >= this.CLUSTER_ZOOM_THRESHOLD;
    } else if (this.bounds) {
      this.map.fitBounds(this.bounds);
      // Asegurar que el zoom después de fitBounds permita clustering
      setTimeout(() => {
        const zoomAfterFitBounds = this.map.getZoom();
        if (zoomAfterFitBounds >= this.CLUSTER_ZOOM_THRESHOLD) {
          this.map.setZoom(this.CLUSTER_ZOOM_THRESHOLD - 1);
          this.currentZoom = this.CLUSTER_ZOOM_THRESHOLD - 1;
          this.showIndividualMarkers = false;
        } else {
          this.currentZoom = zoomAfterFitBounds;
          this.showIndividualMarkers = false;
        }
      }, 100);
    }
  }
  
  addMarker(item: CustomMap) {
    if (!item.LocationAddress?.Location) { return; } 
    let index = this.indexTable.indexOf(item.EndpointID);

    let findCustomIcon = this._appService.onMapIconDetails.value.CustomMapsIcons.find(x => x.MapIconID === item.IconID);
    const iconUrl = findCustomIcon ? findCustomIcon.Default : "assets/icons/default.png";
    const iconSize = !item.IconID || item.IconID === 0 ? new google.maps.Size(25, 40) : new google.maps.Size(32, 32);
    
    const pointColor = this.getHexColorFromNumber(item.Points?.Color);

    const updateMarkerData = (targetIndex: number, isNew: boolean) => {
      let finalIconUrl = iconUrl;
      let finalIconSize = iconSize;
      if (pointColor) {
        finalIconUrl = this.generateColoredPinIcon(pointColor);
        finalIconSize = new google.maps.Size(24, 32);
      }

      const image = {
        url: finalIconUrl,
        size: new google.maps.Size(40, 40),
        scaledSize: finalIconSize
      };

      if (isNew) {
        const cluster = {
          customMap: item,
          markerData: {
            latitude: item.LocationAddress.Location.Latitude,
            longitude: item.LocationAddress.Location.Longitude,
            url: image,
            metadata: { id: item.EndpointID },
            html: this.generateTooltipHTML(item),
            pointColor: pointColor
          }
        };
        this.indexTable.push(item.EndpointID);
        this.clustersFullList.push(cluster);
        this.clustersFilteredList.push(cluster);

        if (this.firstExecution) {
          this.bounds.extend(new google.maps.LatLng(item.LocationAddress.Location.Latitude, item.LocationAddress.Location.Longitude));
        }
      } else {
        this.clustersFullList[targetIndex].customMap = item;
        this.clustersFullList[targetIndex].markerData.url = image;
        this.clustersFullList[targetIndex].markerData.latitude = item.LocationAddress.Location.Latitude;
        this.clustersFullList[targetIndex].markerData.longitude = item.LocationAddress.Location.Longitude;
        this.clustersFullList[targetIndex].markerData.pointColor = pointColor;

        const existingMarker = this.markers.find(m => (m as any).endpointId === item.EndpointID);
        if (existingMarker) {
          existingMarker.setPosition(new google.maps.LatLng(item.LocationAddress.Location.Latitude, item.LocationAddress.Location.Longitude));
          existingMarker.setIcon(image);
          existingMarker.setTitle(item.DisplayText || '');
        }

        if (this.clustersFilteredList[targetIndex]) {
          this.clustersFilteredList[targetIndex].customMap = item;
          this.clustersFilteredList[targetIndex].markerData.url = image;
          this.clustersFilteredList[targetIndex].markerData.latitude = item.LocationAddress.Location.Latitude;
          this.clustersFilteredList[targetIndex].markerData.longitude = item.LocationAddress.Location.Longitude;
          this.clustersFilteredList[targetIndex].markerData.pointColor = pointColor;
        }
      }
    };

    updateMarkerData(index, index === -1);
  }

  private generateTooltipHTML(item: CustomMap): string {
    const values = item.Points;
    
    const isMetricMap = values.MetricSymbol !== undefined && values.MetricSymbol !== null && 
    values.MetricValue !== undefined && values.MetricValue !== null;
    const isConsumptionMap = (values.TotalActiveConsumption !== undefined && values.TotalActiveConsumption !== null) || 
    (values.TotalFlow !== undefined && values.TotalFlow !== null);
    
    let mapIcon = 'fa-plug';
    
    if (isMetricMap) {
      mapIcon = 'fa-chart-line';
    } else if (isConsumptionMap) {
      mapIcon = 'fa-bolt';
    }
    
    const tooltipKey = `${item.EndpointID}_${values.MetricValue}_${values.TotalActiveConsumption}_${values.TotalFlow}`;
    if (this._tooltipCache && this._tooltipCache[tooltipKey]) {
      return this._tooltipCache[tooltipKey];
    }
     
    let tooltipContent = `
    <div class="marker-tooltip">
      <div class="tooltip-header">
        <span class="tooltip-title text-primary">
          <i class="fa-solid ${mapIcon} mr-1"></i> ${item.DisplayText}
        </span>
        <span class="tooltip-close mb-1" onclick="window.dispatchEvent(new CustomEvent('close-info-window'))">✖</span>
      </div>
      <div class="tooltip-body mt-1">
        <span class="tooltip-description">
          <i class="fa-solid fa-thumbtack mr-1"></i> ${item.Facility?.Description} - ${item.Facility?.DisplayText}
        </span>
      </div>
      <div class="tooltip-values mt-2">
    `;
    
    if (isMetricMap && values.MetricValue !== null) {
      tooltipContent += `
        <div class="tooltip-value-item">
          <span class="tooltip-label">Status:</span>
          <span class="tooltip-value">${values.MetricValue} ${values.MetricSymbol || ''}</span>
        </div>
      `;
    }
    
    if (isConsumptionMap) {
      if (values.TotalActiveConsumption) {
        tooltipContent += `
          <div class="tooltip-value-item">
            <i class="fa-solid fa-bolt text-success"></i>
            <span class="tooltip-label">${this._gearService.GearCommonLiterals.Consumption}</span>
            <span class="tooltip-value">${values.TotalActiveConsumption}</span>
          </div>
        `;
      }
      
      if (values.TotalFlow) {
        tooltipContent += `
          <div class="tooltip-value-item">
            <i class="fa-solid fa-water text-info"></i>
            <span class="tooltip-label">${this._appService.CoreCommonLiterals.Flow}</span>
            <span class="tooltip-value">${values.TotalFlow}</span>
          </div>
        `;
      }
    }
  
        tooltipContent += `
        </div>
      </div>
    `;
     
    if (!this._tooltipCache) {
      this._tooltipCache = {};
    }
    this._tooltipCache[tooltipKey] = tooltipContent;
    
    return tooltipContent;
  }

  colorizeIcon(iconUrl: string, color: string, width: number, height: number): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous"; 
      img.src = iconUrl;
  
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
  
        ctx.drawImage(img, 0, 0, width, height);
  
        ctx.globalCompositeOperation = "source-atop";
        ctx.fillStyle = color;
        ctx.fillRect(0, 0, width, height);
  
        const coloredIcon = canvas.toDataURL();
        resolve(coloredIcon);
      };

      img.onerror = () => {
        reject(new Error('Error loading image'));
      };
    });
  }

  generateColoredPinIcon(color: string): string {
    const svg = `
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="32" viewBox="0 0 24 32">
        <defs>
          <filter id="shadow" x="-20%" y="-20%" width="140%" height="140%">
            <feDropShadow dx="0" dy="1" stdDeviation="0.8" flood-opacity="0.3"/>
          </filter>
        </defs>
        <path d="M12 0C5.373 0 0 5.373 0 12c0 6.627 12 20 12 20s12-13.373 12-20C24 5.373 18.627 0 12 0z" 
              fill="${color}" filter="url(#shadow)"/>
        <circle cx="12" cy="10" r="4.5" fill="white"/>
      </svg>
    `;
    return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg);
  }

  getHexColorFromNumber(colorNumber: number): string | null {
    if (colorNumber === null || colorNumber === undefined || colorNumber === 0) {
      return null;
    }
    return this.colorService.rgbToHexa(colorNumber);
  }

  getLighterBackgroundColor(hexColor: string, opacity: number = 0.15): string | null {
    if (!hexColor) {
      return null;
    }
    const hex = hexColor.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }

  async onMapReady(map: google.maps.Map) {
    if(environment.useOfflineMode) {
      return;
    }
    
    try {
      this.map = map;
      this.mapApiReady = true;

      await new Promise(resolve => setTimeout(resolve, 100));

      if (!this.map || !this.map.getDiv()) {
        return;
      }

      await this.loadMarkerLibraries();
      
      if(this._appService.getClientID()) {
        this.clientID = this._appService.getClientID();
        if (this.facilitiesIds.length > 0) {
          setTimeout(() => {
            this.initData();
          }, 200);
        }
      }

      this.subscriptions.push(this._appService.onFacilitySet.subscribe(_ => {
        const clientID = this._appService.getClientID();
        if (this.clientID === clientID) { return; }
        this.clientID = clientID;
      }));
     
      this.currentZoom = this.map.getZoom() || 0;
      this.showIndividualMarkers = this.currentZoom >= this.CLUSTER_ZOOM_THRESHOLD;
      
    } catch (error) {
      console.error('Error in onMapReady:', error);
    }
  }

  private async loadMarkerLibraries() {
    try {
      const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;
      this.AdvancedMarkerElement = AdvancedMarkerElement;
      this.PinElement = PinElement;
    } catch (error) {}
  }
  
  tryGetMapFromViewChild() {
    if (this.mapComponent && this.mapComponent.googleMap && typeof this.mapComponent.googleMap.setCenter === 'function') {
      this.map = this.mapComponent.googleMap;
      setTimeout(() => this.centerMapInitially(), 100);
    }
  }

  createHeatmapButtons() {
    const buttonsConfig = [
      { id: 'toggle-heatmap-consumption', text: 'Toggle Heatmap', action: () => this.toggleHeatmap() },
      { id: 'change-gradient-consumption', text: 'Change Gradient', action: () => this.changeGradient() },
      { id: 'change-radius-consumption', text: 'Change Radius', action: () => this.changeRadius() }
    ];

    const existingButtons = document.querySelectorAll('#toggle-heatmap-consumption, #change-gradient-consumption, #change-radius-consumption');
    existingButtons.forEach(button => button.remove());
    const buttonContainer = document.createElement('div');
    buttonContainer.id = 'heatmap-controls';
    buttonsConfig.forEach(config => {
      const button = document.createElement('button');
      button.id = config.id;
      button.innerText = config.text;
      button.addEventListener("click", config.action);
      buttonContainer.appendChild(button);
    });

    const mapDiv = this.map?.getDiv();
    if (mapDiv) {
      mapDiv.appendChild(buttonContainer);
    }
  }

  generateHeatmapData() {
    this.clearClustering();
    this.hideTooltip();
    this.clearHeatmapMarkers();
    
    this.heatmapData = [];
    let minWeight = Infinity;
    let maxWeight = 0;
    
    this.clustersFullList.forEach((item) => {
      const weight = item.customMap?.Points?.Weight || 0;
      if (weight > 0) {
        if (weight > maxWeight) maxWeight = weight;
        if (weight < minWeight) minWeight = weight;
      }
    });

    if (maxWeight === 0) {
      maxWeight = 1;
      minWeight = 0;
    }
    if (minWeight === Infinity) {
      minWeight = 0;
    }
    
    const weightRange = maxWeight - minWeight;
    const useLogScale = weightRange > 100;
    
    this.clustersFullList.forEach((item) => {
      if (item.customMap && item.customMap.LocationAddress?.Location) {
        const latLng = new google.maps.LatLng(
          item.customMap.LocationAddress.Location.Latitude, 
          item.customMap.LocationAddress.Location.Longitude
        );
        
        const rawWeight = item.customMap.Points?.Weight || 1;
        let scaledWeight: number;
        
        if (useLogScale) {
          scaledWeight = Math.log10(rawWeight + 1) * 5;
        } else {
          const normalized = weightRange > 0 ? (rawWeight - minWeight) / weightRange : 0.5;
          scaledWeight = 1 + (normalized * 9); 
        }
        
        this.heatmapData.push({
          location: latLng,
          weight: scaledWeight
        } as google.maps.visualization.WeightedLocation);
        
        const transparentIcon = {
          path: google.maps.SymbolPath.CIRCLE,
          scale: 12,
          fillColor: 'transparent',
          fillOpacity: 0,
          strokeWeight: 0
        };
        
        const heatmapMarker = new google.maps.Marker({
          position: latLng,
          map: this.map,
          icon: transparentIcon,
          cursor: 'pointer'
        });
        
        heatmapMarker.addListener('mouseover', () => {
          this._currentHeatmapMarker = heatmapMarker;
          
          if (this._heatmapTooltipTimeout) {
            clearTimeout(this._heatmapTooltipTimeout);
          }
          
          this.showTooltipAtPosition(item, latLng);
        });
        
        heatmapMarker.addListener('mouseout', () => {
          this._heatmapTooltipTimeout = setTimeout(() => {
            if (this._currentHeatmapMarker === heatmapMarker) {
              this.hideTooltip();
              this._currentHeatmapMarker = null;
            }
          }, 200);
        });
        
        heatmapMarker.addListener('click', () => {
          const markerData: IconMarker = {
            url: '',
            html: this.generateTooltipHTML(item.customMap),
            latitude: item.customMap.LocationAddress.Location.Latitude,
            longitude: item.customMap.LocationAddress.Location.Longitude,
            metadata: { id: item.customMap.EndpointID }
          };
          this.onMarkerClick(markerData);
        });
        
        this.heatmapMarkers.push(heatmapMarker);
      }
    }); 
    
    if (this.heatmap) {
      this.heatmap.setData(this.heatmapData);
    } else {
      this.heatmap = new google.maps.visualization.HeatmapLayer({
        data: this.heatmapData,
        map: this.map,
        radius: 25,
        opacity: 0.8
      });
    }
  }
  
  private clearHeatmapMarkers() {
    if (this._heatmapTooltipTimeout) {
      clearTimeout(this._heatmapTooltipTimeout);
    }
    this._currentHeatmapMarker = null;
    
    this.heatmapMarkers.forEach(marker => {
      marker.setMap(null);
    });
    this.heatmapMarkers = [];
  }
  
  private showTooltipAtPosition(item: any, latLng: google.maps.LatLng) {
    if (!this.infoWindow) {
      this.infoWindow = new google.maps.InfoWindow();
    }
    
    const tooltipHTML = this.generateTooltipHTML(item.customMap);
    this.infoWindow.setContent(tooltipHTML);
    this.infoWindow.setPosition(latLng);
    this.infoWindow.open(this.map);
  }

  onMarkerClick(marker: IconMarker) {
    this._appService.startLoading();
    this._gearProxyService.RealTimeDataService.GetCustomMapDataPacketDetail(
      this._appService.getAccessToken(),
      this._appService.getClientID(),
      this.mapId,
      marker.metadata.id,
      (details: CoreTypes.CustomMapDataPacketDetail) => {
        this._appService.stopLoading();
        this.customMapID = details.Endpoint.EndpointID;
        this.customMapData = details;
        this._customMapModal.open();
      }, (error) => {
        this._appService.stopLoading();
        this._appService.showException(error);
      }
    );
  }

  onCustomMapModalClose() {
    this.customMapData = null;
    this.customMapID = 0;
  }

  onCenterChange($event) {
    // Método para manejar cambios en el centro del mapa
  }

  boundsChange($event) {
    // Método para manejar cambios en los bounds del mapa
  }

  onZoomChange($event) {
    clearTimeout(this.debounceAction);
    this.debounceAction = setTimeout(() => {
      if (this.enableHeatmap) { return; }
      
      let newZoom = 0;
      if ($event && $event.target && typeof $event.target.getZoom === 'function') {
        newZoom = $event.target.getZoom();
      } else if (this.map && typeof this.map.getZoom === 'function') {
        newZoom = this.map.getZoom();
      }
      
      if (newZoom === this.currentZoom) { return; }
      
      const previousZoom = this.currentZoom;
      this.currentZoom = newZoom;
      const wasAboveThreshold = previousZoom >= this.CLUSTER_ZOOM_THRESHOLD;
      const isAboveThreshold = this.currentZoom >= this.CLUSTER_ZOOM_THRESHOLD;
      
      if (isAboveThreshold && !wasAboveThreshold) {
        this.showIndividualMarkers = true;
        this.clearClustering();
        this.showIndividualMarkersOnMap();
        this.hideTooltip();
      } else if (!isAboveThreshold && wasAboveThreshold) {
        this.showIndividualMarkers = false;
        this.hideTooltip();
        
        if (this.markers && this.markers.length > 0) {
          this.markers.forEach(marker => {
            marker.setMap(null);
          });
          this.markers = [];
        }
        
        this._lastClusteringData = '';
        setTimeout(async () => {
          await this.updateClustering();
        }, 50);
      }
    }, 150);
  }

  search(e: any) {
    let value: string = this._accentFoldService.accentFold(e.target.value.toLowerCase());

    if(value.length > 0) {
      this.clustersFilteredList = this.clustersFullList.filter((item) => {
        let displayText = this._accentFoldService.accentFold(item.customMap.DisplayText.toLowerCase());
        let description = this._accentFoldService.accentFold(item.customMap.Facility.Description.toLowerCase());
        return displayText.indexOf(value) > -1 || description.indexOf(value) > -1;
      });
    } else {
      this.clustersFilteredList = this.clustersFullList;
    }
    
    if (!this.enableHeatmap) {
      if (this.showIndividualMarkers) {
        this.updateMarkers();
      } else {
        this.updateClustering();
      }
    }
  }

  goToWithDevice(facility, device: CoreTypes.DeviceMap, route: string) {
    this.sharedService.goToWithFacilityOrDevice(facility, route, device);
  }

  openCameraModal(link: string) {
    return this._router.navigate(['/', {outlets: {modal: ['camera', btoa(link)]}}]);
  }

  applyFilters(controlName:string) {
    clearTimeout(this.debounceAction);
    this.debounceAction = setTimeout(() => {
      if(controlName === 'facilities'){
        if(this.facilitiesIds.length > 0) {
          this.clustersFilteredList = this.clustersFullList.filter(item => 
            this.facilitiesIds.includes(item.customMap.Facility.FacilityID)
          );
        } else {
          this.clustersFilteredList = this.clustersFullList;
        }
        
        // Actualizar markers según el modo actual
        if (!this.enableHeatmap) {
          if (this.showIndividualMarkers) {
            this.updateMarkers();
          } else {
            this.updateClustering();
          }
        }
      }
    }, 300);
  }

  emitChangeParam(event: any) {
    // Método para emitir cambios de parámetros
    console.log(event, "event");
  }

  toggleHeatmap() {
    if (this.heatmap && this.heatmap.getMap()) {
      this.heatmap?.setMap(null);
    } else {
      if (!this.heatmap) {
        this.heatmap = new google.maps.visualization.HeatmapLayer({
          data: this.heatmapData,
          map: this.map
        });
      } else {
        this.heatmap?.setMap(this.map);
      }
    }
  }

  changeGradient(): void {
    const gradient = [
      "rgba(0, 255, 255, 0)",
      "rgba(0, 255, 255, 1)",
      "rgba(0, 191, 255, 1)",
      "rgba(0, 127, 255, 1)",
      "rgba(0, 63, 255, 1)",
      "rgba(0, 0, 255, 1)",
      "rgba(0, 0, 223, 1)",
      "rgba(0, 0, 191, 1)",
      "rgba(0, 0, 159, 1)",
      "rgba(0, 0, 127, 1)",
      "rgba(63, 0, 91, 1)",
      "rgba(127, 0, 63, 1)",
      "rgba(191, 0, 31, 1)",
      "rgba(255, 0, 0, 1)",
    ];
  
    this.heatmap.set("gradient", this.heatmap.get("gradient") ? null : gradient);
  }

  changeRadius(): void {
    this.heatmap.set("radius", this.heatmap.get("radius") ? null : 20);
  }

  clearHeatmapData(): void {
    if (this.heatmap) {
      this.heatmap.setMap(null);
      this.heatmap = null;
    }
    
    this.heatmapData = [];
    
    this.clearClustering();
    
    this.clustersFullList = [];
    this.clustersFilteredList = [];
    this.indexTable = [];
    
    const buttonIds = ['toggle-heatmap-consumption', 'change-gradient-consumption', 'change-radius-consumption'];
    buttonIds.forEach(id => {
      const button = document.getElementById(id);
      if (button) {
        button.remove();
      }
    });
    
    const buttonContainer = document.getElementById('heatmap-controls');
    if (buttonContainer) {
      buttonContainer.remove();
    }
  }

  updateMarkers() {
    if (this.enableHeatmap) { return; }
    
    const currentMarkerIds = new Set(this.markers.map(m => (m as any).endpointId));
    const newMarkerIds = new Set(this.clustersFilteredList.map(c => c.customMap.EndpointID));
    
    // Remover markers que ya no están en la lista filtrada
    this.markers = this.markers.filter(marker => {
      const endpointId = (marker as any).endpointId;
      if (!newMarkerIds.has(endpointId)) {
        marker.setMap(null);
        return false;
      }
      return true;
    });

    // Agregar o actualizar markers
    this.clustersFilteredList.forEach(cluster => {
      const existingMarker = this.markers.find(m => (m as any).endpointId === cluster.customMap.EndpointID);
      
      if (existingMarker) {
        // Actualizar marker existente
        existingMarker.setPosition(new google.maps.LatLng(cluster.markerData.latitude, cluster.markerData.longitude));
        existingMarker.setIcon(cluster.markerData.url);
        existingMarker.setTitle(cluster.customMap.DisplayText || '');
      } else {
        // Crear nuevo marker
        const marker = new google.maps.Marker({
          position: new google.maps.LatLng(cluster.markerData.latitude, cluster.markerData.longitude),
          map: this.map,
          icon: cluster.markerData.url,
          title: cluster.customMap.DisplayText || ''
        });

        (marker as any).facilityId = cluster.customMap.Facility.FacilityID;
        (marker as any).endpointId = cluster.customMap.EndpointID;
        (marker as any).allFacilities = [cluster];

        const infoWindow = new google.maps.InfoWindow({
          content: cluster.markerData.html,
          maxWidth: 300
        });

        marker.addListener('mouseover', () => {
          this._activeMarker = cluster.customMap.EndpointID;
          infoWindow.open(this.map, marker);
        });

        marker.addListener('mouseout', () => {
          this._activeMarker = 0;
          infoWindow.close();
        });

        marker.addListener('click', () => {
          this.onMarkerClick(cluster.markerData);
        });

        this.markers.push(marker);
      }
    });

    // Actualizar clusterer solo si es necesario
    if (this.markerClusterer) {
      this.markerClusterer.clearMarkers();
      this.markerClusterer.addMarkers(this.markers);
    }
  }

  onVisualizationTypeChange(event: any) {
    this.enableHeatmap = this.visualizationType.value === CoreTypes.MapLayerType.Heatmap;
    const buttonIds = ['toggle-heatmap-consumption', 'change-gradient-consumption', 'change-radius-consumption'];
    buttonIds.forEach(id => {
      const button = document.getElementById(id);
      if (button) {
        button.style.display = this.enableHeatmap ? 'block' : 'none';
      }
    });
    
    if (this.enableHeatmap) {
      this.clearClustering();
      this.hideTooltip();
      
      if (!document.getElementById('toggle-heatmap-consumption')) {
        this.createHeatmapButtons();
      }
      this.generateHeatmapData();
    } else {
      this.clustersFilteredList = this.clustersFullList;
      this.heatmap?.setMap(null);
      this.heatmap = null;
      this.clearHeatmapMarkers();
      if (this.showIndividualMarkers) {
        this.updateMarkers();
      } else {
        this.updateClustering();
      }
    }
    
    this.map?.setMapTypeId(this.getMapTypeId(this.visualizationType.value));
  }

  getMapTypeId(layerType: CoreTypes.MapLayerType): string {
    switch (layerType) {
      case CoreTypes.MapLayerType.Roadmap:
        return 'roadmap';
      case CoreTypes.MapLayerType.Satellite:
        return 'satellite';
      case CoreTypes.MapLayerType.Terrain:
        return 'terrain';
      case CoreTypes.MapLayerType.Hybrid:
        return 'hybrid';
      default:
        return 'roadmap';
    }
  }
    
  getCustomMapEndpointVariableType(mapType: number): Promise<void> {
    return new Promise((resolve, reject) => {
      this._gearProxyService.RealTimeDataService.GetCustomMapEndpointVariableType(
        this._appService.getAccessToken(),
        mapType,
        (allowedVariableTypes: number[]) => {
          this._allowedVariableTypes = allowedVariableTypes;
          resolve();
        },
        (err: any) => {
          this._appService.showException(err);
          reject(err);
        }
      );
    });
  }

  private async loadConsumptionVariables(): Promise<void> {
    this.consumptionVariables = [];
    return new Promise((resolve, reject) => {
      this.getCustomMapEndpointVariableType(CoreTypes.CustomMapType.Consumption);
      this._gearProxyService.MasterEntityService.EnumVariableTypes(
        this._appService.getAccessToken(),
        this._appService.getClientID(),
        0,
        0,
        (res: CoreTypes.VariablesTypeData[]) => {
          this._variablesTypeFullList = res;
          this.setVariableType();
          resolve();
        },
        err => {
          this._appService.showException(err);
          reject(err);
        }
      );
    });
  }

  setVariableType() {
    let optionsList: Array<IMultiSelectOption> = new Array<IMultiSelectOption>();        
    this._variablesTypeFullList.forEach((x) => {
      if(this._allowedVariableTypes.includes(x.VariableTypeID)) {
        let item = {
          name: x.Description,
          id: x.VariableTypeID
        };
        optionsList.push(item);
        this.consumptionVariables.push(item.id);
      }
    });
    this.consumptionVariableList = optionsList;
  }

  onAction(event: any) {
    this.activeIcon = event.id;
  }

  private processMarkersInBatches(markers: CustomMap[], batchSize: number = 100) {
    if (markers.length === 0) return;
    
    const processBatch = (startIndex: number) => {
      const endIndex = Math.min(startIndex + batchSize, markers.length);
      
      for (let i = startIndex; i < endIndex; i++) {
        this.addMarker(markers[i]);
      }
      
      if (endIndex < markers.length) {
        requestAnimationFrame(() => processBatch(endIndex));
      }
    };
    
    processBatch(0);
  }

  private showTooltip(marker: google.maps.Marker, item: any) {
    if (!this.infoWindow) {
      this.infoWindow = new google.maps.InfoWindow({
        content: "",
        disableAutoPan: true,
        pixelOffset: new google.maps.Size(0, -40),
        maxWidth: 300
      });
    }

    let targetItem = item;
    const allFacilities = (marker as any).allFacilities;
    if (allFacilities && allFacilities.length > 1) {
      const specificFacility = allFacilities.find(f => f.customMap.EndpointID === item.customMap.EndpointID);
      if (specificFacility) {
        targetItem = specificFacility;
      }
    }

    this.infoWindow.setContent(targetItem.markerData.html);
    this.infoWindow.setPosition(marker.getPosition());
    this.infoWindow.open(this.map);
  }

  private hideTooltip() {
    if (this.infoWindow) {
      this.infoWindow.close();
    }
  }

  onCardHover(item: any) {
    this._activeMarker = item.customMap.EndpointID;
    if (!this.centerMapOnItem(item)) return;
    const marker = this.findMarkerForEndpoint(this._activeMarker);
    if (marker) {
      this._currentTooltipMarker = marker;
      this.showTooltip(marker, item);
    }
  }
  
  private centerMapOnItem(item: any): boolean {
    const lat = item.customMap.LocationAddress.Location.Latitude;
    const lng = item.customMap.LocationAddress.Location.Longitude;
    if (this.map && lat && lng && lat !== 0 && lng !== 0) {
      this.map.panTo(new google.maps.LatLng(lat, lng));
      return true;
    }
    return false;
  }
  
  
  onCardMouseOut() {
    this._activeMarker = 0;
    if (this._currentTooltipMarker) {
      this.hideTooltip();
      this._currentTooltipMarker = null;
    }
  }

  private showIndividualMarkersOnMap() {
    if (!this.map || !this.showIndividualMarkers || this.enableHeatmap) { return; }
    if (this.markers.length === 0) {
      const itemsToShow = this.clustersFilteredList.length > 0 ? 
        this.clustersFilteredList : this.clustersFullList;

      itemsToShow.filter(item =>
        item.customMap.LocationAddress?.Location?.Latitude != null &&
        item.customMap.LocationAddress?.Location?.Longitude != null
      ).forEach((item) => {
        const lat = item.customMap.LocationAddress.Location.Latitude;
        const lng = item.customMap.LocationAddress.Location.Longitude;

        let pointColor = item.markerData?.pointColor;
        if (!pointColor && item.customMap?.Points?.Color) {
          pointColor = this.getHexColorFromNumber(item.customMap.Points.Color);
        }
        let iconUrl = item.markerData.url;
        if (pointColor) {
          iconUrl = {
            url: this.generateColoredPinIcon(pointColor),
            size: new google.maps.Size(40, 40),
            scaledSize: new google.maps.Size(24, 32)
          };
        }
          
        const marker = new google.maps.Marker({
          position: { lat, lng },
          icon: iconUrl,
          title: item.customMap.DisplayText,
          map: this.map
        });
          
        marker.addListener("click", () => {
          this.onMarkerClick(item.markerData);
        });

        marker.addListener("mouseover", () => {
          this._currentTooltipMarker = marker;
          
          if (this._tooltipTimeout) {
            clearTimeout(this._tooltipTimeout);
            this._tooltipTimeout = null;
          }
          this.showTooltip(marker, item);
        });

        marker.addListener("mouseout", () => {
          this._tooltipTimeout = setTimeout(() => {
            if (!this._isMouseOverTooltip) {
              this.hideTooltip();
              this._currentTooltipMarker = null;
            }
          }, 200);
        });
        
        (marker as any).customMapData = item.customMap;
        (marker as any).endpointId = item.customMap.EndpointID;
        (marker as any).facilityId = item.customMap.Facility.FacilityID;
        (marker as any).allFacilities = [item];
        
        this.markers.push(marker);
      });
    } else {
      this.markers.forEach(marker => {
        if (marker.getMap() !== this.map) {
          marker.setMap(this.map);
        }
      });
    }
  }

  async updateClustering() {
    if (!this.map || this._isUpdatingClustering || this.enableHeatmap) { return; }
    
    if (this.currentZoom >= this.CLUSTER_ZOOM_THRESHOLD) {
      this.clearClustering();
      return;
    }
    
    if (!this.map.getDiv() || !(this.map.getDiv() as HTMLElement).offsetWidth) {
      setTimeout(async () => await this.updateClustering(), 100);
      return;
    }
    
    if (this.clustersFilteredList.length === 0) {
      this.clustersFilteredList = [...this.clustersFullList];
    }

    if (!this.AdvancedMarkerElement || !this.PinElement) {
      await this.loadMarkerLibraries();
    }

    const currentData = JSON.stringify(this.clustersFilteredList.map(item => ({
      id: item.customMap.EndpointID,
      lat: item.customMap.LocationAddress?.Location?.Latitude,
      lng: item.customMap.LocationAddress?.Location?.Longitude
    })));
    
    const currentFacilityId = this._appService.getFacilityID();
    const facilityChanged = this._lastFacilityId !== currentFacilityId;
    
    if (currentData === this._lastClusteringData && this.clusterer && this.markers.length > 0 && !facilityChanged) {
      return;
    }
    
    if (facilityChanged) {
      this._lastFacilityId = currentFacilityId;
    }
    
    this._lastClusteringData = currentData;
    this._isUpdatingClustering = true;
    
    try {
      if (this.clusterer) {
        try {
          this.clusterer.clearMarkers();
        } catch (error) {
        }
        this.clusterer = null;
      }
      
      if (this.markers && this.markers.length > 0) {
        this.markers.forEach(marker => {
          try {
            if (marker && marker.setMap) {
              marker.setMap(null);
            }
          } catch (error) {
          }
        });
        this.markers = [];
      }
      
      const validItems = this.clustersFilteredList.filter(item => {
        if (!item || !item.customMap || !item.customMap.LocationAddress || !item.customMap.LocationAddress.Location) {
          return false;
        }
        
        const lat = item.customMap.LocationAddress.Location.Latitude;
        const lng = item.customMap.LocationAddress.Location.Longitude;
        
        return lat != null && lng != null && 
               !isNaN(lat) && !isNaN(lng) &&
               lat >= -90 && lat <= 90 &&
               lng >= -180 && lng <= 180 &&
               (lat !== 0 || lng !== 0);
      });
      
      if (validItems.length === 0) {
        return;
      }
      
      const markersByPosition = new Map<string, any[]>();
      
      validItems.forEach((item) => {
        const lat = item.customMap.LocationAddress.Location.Latitude;
        const lng = item.customMap.LocationAddress.Location.Longitude;
        const positionKey = `${lat.toFixed(4)},${lng.toFixed(4)}`;
        
        if (!markersByPosition.has(positionKey)) {
          markersByPosition.set(positionKey, []);
        }
        markersByPosition.get(positionKey).push(item);
      });

      this.markers = Array.from(markersByPosition.entries()).map(([positionKey, items]) => {
        const selectedItem = items[0];
        const lat = selectedItem.customMap.LocationAddress.Location.Latitude;
        const lng = selectedItem.customMap.LocationAddress.Location.Longitude;
        
        let pointColor = selectedItem.markerData?.pointColor;
        if (!pointColor && selectedItem.customMap?.Points?.Color) {
          pointColor = this.getHexColorFromNumber(selectedItem.customMap.Points.Color);
        }
        
        let iconUrl = selectedItem.markerData?.url;
        if (pointColor) {
          iconUrl = {
            url: this.generateColoredPinIcon(pointColor),
            size: new google.maps.Size(40, 40),
            scaledSize: new google.maps.Size(24, 32)
          };
        }
        
        const marker = new google.maps.Marker({
          position: { lat, lng },
          icon: iconUrl || undefined,
          title: items.length > 1 ? 
            `${items.length} elementos - ${selectedItem.customMap.DisplayText}` : 
            selectedItem.customMap.DisplayText,
          map: null
        });
        
        marker.addListener("click", () => {
          this.onMarkerClick(selectedItem.markerData);
        });

        marker.addListener("mouseover", () => {
          this._currentTooltipMarker = marker;
          
          if (this._tooltipTimeout) {
            clearTimeout(this._tooltipTimeout);
            this._tooltipTimeout = null;
          }
          this.showTooltip(marker, selectedItem);
        });

        marker.addListener("mouseout", () => {
          this._tooltipTimeout = setTimeout(() => {
            if (!this._isMouseOverTooltip) {
              this.hideTooltip();
              this._currentTooltipMarker = null;
            }
          }, 200);
        });
        
        (marker as any).customMapData = selectedItem.customMap;
        (marker as any).endpointId = selectedItem.customMap.EndpointID;
        (marker as any).facilityId = selectedItem.customMap.Facility.FacilityID;
        (marker as any).allFacilities = items;
        
        return marker;
      });
      
      const validMarkers = this.markers.filter(marker => {
        try {
          const position = marker.getPosition();
          if (!position) return false;
          
          const lat = position.lat();
          const lng = position.lng();
          
          return lat != null && lng != null && 
            !isNaN(lat) && !isNaN(lng) &&
            lat >= -90 && lat <= 90 &&
            lng >= -180 && lng <= 180 &&
            (lat !== 0 || lng !== 0);
        } catch (error) {
          return false;
        }
      });
      
      if (validMarkers.length === 0) {
        return;
      }
      
      try {
        const algorithm = new SuperClusterAlgorithm({
          radius: 300,
          maxZoom: this.CLUSTER_ZOOM_THRESHOLD
        });
        
        this.clusterer = new MarkerClusterer({
          map: this.map,
          markers: validMarkers,
          algorithm,
          renderer: {
            render: ({ count, position, markers }) => {
              try {
                const firstMarker = markers[0] as any;
                const firstItem = firstMarker?.allFacilities?.[0];
                let clusterColor = firstItem?.markerData?.pointColor;
                if (!clusterColor && firstItem?.customMap?.Points?.Color) {
                  clusterColor = this.getHexColorFromNumber(firstItem.customMap.Points.Color);
                }
                clusterColor = clusterColor || '#2ecc71';
                
                const svg = `
                  <svg xmlns="http://www.w3.org/2000/svg" height="54" width="54">
                    <circle cx="27" cy="27" r="16" fill-opacity="0.5" fill="${clusterColor}"/> 
                    <circle cx="27" cy="27" r="18" fill-opacity="0.8" fill="${clusterColor}"/>
                    <circle cx="27" cy="27" r="20" fill-opacity="0.5" fill="${clusterColor}"/>
                    <circle cx="27" cy="27" r="22" fill-opacity="0.2" fill="${clusterColor}"/>
                    <circle cx="27" cy="27" r="24" fill-opacity="0.3" fill="${clusterColor}"/>
                    <text x="27" y="32" text-anchor="middle" font-size="14" font-family="Arial" fill="white" font-weight="bold">${count}</text>
                  </svg>
                `;
                const div = document.createElement("div");
                div.innerHTML = svg;
                const clusterMarker = new this.AdvancedMarkerElement({
                  position,
                  content: div,
                });
                  
                clusterMarker.addListener("click", () => {
                  if (count > 1) {
                    const bounds = new google.maps.LatLngBounds();
                    markers.forEach(marker => {
                      const pos = marker.getPosition();
                      if (pos) {
                        bounds.extend(pos as google.maps.LatLng);
                      }
                    });
                    this.map.fitBounds(bounds, 50);
                  }
                });
                  
                return clusterMarker;
              } catch (error) {
                return new google.maps.Marker({
                  position,
                  label: count.toString(),
                  map: this.map
                });
              }
            }
          }
        } as any);
      } catch (clusterError) {
        validMarkers.forEach(marker => {
          marker.setMap(this.map);
        });
      }
    } catch (error) {
    } finally {
      this._isUpdatingClustering = false;
    }
  }

  private clearClustering() {
    if (this.clusterer) {
      this.clusterer.clearMarkers();
      this.clusterer = null;
    }
    
    if (this.markers && this.markers.length > 0) {
      this.markers.forEach(marker => {
        marker.setMap(null);
      });
      this.markers = [];
    }
    
    this._lastClusteringData = '';
  }

  private findMarkerForEndpoint(endpointId: number): google.maps.Marker | null {
    const directMarker = this.markers.find(m => (m as any).endpointId === endpointId);
    if (directMarker) {
      return directMarker;
    }
    for (const marker of this.markers) {
      const allFacilities = (marker as any).allFacilities;
      if (allFacilities && allFacilities.some(f => f.customMap.EndpointID === endpointId)) {
        return marker;
      }
    }
    return null;
  }
  
  back() {
    if(this._appService?.client?.Client?.MapSettings?.CustomMaps?.length) {
      const customMapId = this._appService.client.Client.MapSettings.CustomMaps[0].CustomMapID;
      const mapId = customMapIndicator + customMapId;
      this._router.navigate(["../../custom", mapId], { relativeTo: this._activatedRoute });
    } else {
      this._router.navigate(["/default"], { relativeTo: this._activatedRoute });
    }
  }


  formatDateTimeDT(dateTime: CoreTypes.DateTimeDT): string {
    if (!dateTime || !dateTime.Date || !dateTime.Time) {
      return '';
    }
    const date = dateTime.Date;
    const time = dateTime.Time;
    const formattedDate = `${date.Day.toString().padStart(2, '0')}/${date.Month.toString().padStart(2, '0')}/${date.Year}`;
    const formattedTime = `${time.Hour.toString().padStart(2, '0')}:${time.Minute.toString().padStart(2, '0')}:${time.Second.toString().padStart(2, '0')}`;

    return `${formattedDate} ${formattedTime}`;
  }

}
